import { createAction } from '../../utils/redux/createAction';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';
import { consts as accountVaultsFormConsts } from './accountVaultsForm';

const actionsScope = 'programs/payment-info-modal';

export const PAYMENT_INFO_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
  CLEAR_PAYA_FORM: `${actionsScope}/clear-paya-form`,
  RECEIVE_PAYA_FORM: `${actionsScope}/receive-paya-form`,
  RECEIVED_PAYA_PAYMENT_SUCCESS_RESPONSE: `${actionsScope}/received-paya-payment-success-response`,
  RECEIVED_PAYA_PAYMENT_ERROR_RESPONSE: `${actionsScope}/received-paya-payment-error-response`,
  WAITING_PAYA_PAYMENT_RESPONSE: `${actionsScope}/waiting-paya-payment-response`,
  CLEAR_WAITING_PAYA_PAYMENT_RESPONSE: `${actionsScope}/clear-waiting-paya-payment-response`,
};

export const paymentInfoModalActions = {
  open: createAction(PAYMENT_INFO_MODAL.OPEN),
  close: createAction(PAYMENT_INFO_MODAL.CLOSE),
  clearPayaForm: createAction(PAYMENT_INFO_MODAL.CLEAR_PAYA_FORM),
  receivePayaForm: createAction(PAYMENT_INFO_MODAL.RECEIVE_PAYA_FORM),
  waitingPayaPaymentResponse: createAction(
    PAYMENT_INFO_MODAL.WAITING_PAYA_PAYMENT_RESPONSE,
  ),
  clearWaitingPayaPaymentResponse: createAction(
    PAYMENT_INFO_MODAL.CLEAR_WAITING_PAYA_PAYMENT_RESPONSE,
  ),
  receivedPayaPaymentSuccessResponse: createAction(
    PAYMENT_INFO_MODAL.RECEIVED_PAYA_PAYMENT_SUCCESS_RESPONSE,
  ),
  receivedPayaPaymentErrorResponse: createAction(
    PAYMENT_INFO_MODAL.RECEIVED_PAYA_PAYMENT_ERROR_RESPONSE,
  ),
};

const initialState = {
  opened: false,
  subscriptionsSetting: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PAYMENT_INFO_MODAL.OPEN: {
      const {
        subscriptionsSetting,
        programId,
        userId,
        todoId,
        invitationId,
        mainUserId,
        programName,
        prepayFlow,
        organizationId,
        purchaseAgain,
        duePaymentDate,
      } = payload;
      return {
        ...state,
        userId,
        todoId,
        programId,
        mainUserId,
        opened: true,
        organizationId,
        invitationId,
        programName,
        purchaseAgain,
        prepayFlow,
        duePaymentDate,
        subscriptionsSetting,
      };
    }

    case PAYMENT_INFO_MODAL.CLOSE:
    case LOCATION_CHANGE: {
      return {
        ...initialState,
      };
    }

    case PAYMENT_INFO_MODAL.WAITING_PAYA_PAYMENT_RESPONSE: {
      return {
        ...state,
        waitingPayaPaymentResponse: true,
      };
    }

    case PAYMENT_INFO_MODAL.CLEAR_WAITING_PAYA_PAYMENT_RESPONSE: {
      return {
        ...state,
        waitingPayaPaymentResponse: false,
      };
    }

    case PAYMENT_INFO_MODAL.CLEAR_PAYA_FORM: {
      return {
        ...state,
        payaFormUrl: '',
      };
    }

    case accountVaultsFormConsts.SEND: {
      return {
        ...state,
        payaFormLoading: true,
      };
    }

    case PAYMENT_INFO_MODAL.RECEIVE_PAYA_FORM: {
      return {
        ...state,
        payaFormLoading: false,
        payaFormUrl: payload.formUrl,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/programs/payment-info-modal.js